/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Commercial_Ad_LabelInputs */

const en_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commercial content`)
};

const fr_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contenu commercial`)
};

const de_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommerzielle Inhalte`)
};

const it_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuti commerciali`)
};

const ru_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коммерческий контент`)
};

const es_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido comercial`)
};

const zh_cn2_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商业内容`)
};

const ja_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商用コンテンツ`)
};

const hi_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वाणिज्यिक सामग्री`)
};

const pt_pt2_ad_commercial_ad_label = /** @type {(inputs: Ad_Commercial_Ad_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo comercial`)
};

/**
* | output |
* | --- |
* | "Commercial content" |
*
* @param {Ad_Commercial_Ad_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_commercial_ad_label = /** @type {((inputs?: Ad_Commercial_Ad_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Commercial_Ad_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_commercial_ad_label(inputs)
	if (locale === "de") return de_ad_commercial_ad_label(inputs)
	if (locale === "it") return it_ad_commercial_ad_label(inputs)
	if (locale === "ru") return ru_ad_commercial_ad_label(inputs)
	if (locale === "es") return es_ad_commercial_ad_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_commercial_ad_label(inputs)
	if (locale === "ja") return ja_ad_commercial_ad_label(inputs)
	if (locale === "hi") return hi_ad_commercial_ad_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_commercial_ad_label(inputs)
	return en_ad_commercial_ad_label(inputs)
});